import { useCallback } from "react";
import { ListChecks } from "lucide-react";

import BaseTableV3 from "components/BaseTableV3/BaseTableV3";
import { getNextQueryParams } from "components/helpers";
import RevenueOpportunityService from "services/RevenueOpportunities";
import {
  useRevenueOpportunityStatusTable,
  invalidateRevenueOpportunityStatusQuery,
} from "hooks/useRevenueOpportunityStatusTable";
import FormDialog from "components/modals/FormDialog";
import RevenueOpportunityStatusForm, {
  STATUS_DIALOG_CLASS_NAME,
} from "components/forms/RevenueOpportunityStatusForm";

export const REVENUE_OPPORTUNITY_STATUS_TABLE_CONSTANTS = {
  tableName: "revenue_opportunity_status",
  queryKey: "revenue_opportunity_statuses",
  className: "RevenueOpportunityStatus",
  exportTableName: "RevenueOpportunityStatusTable",
  header: "Revenue Opportunity Status",
  headerIcon: ListChecks,
};

const RevenueOpportunityStatusTableV3 = () => {
  const { columns } = useRevenueOpportunityStatusTable();

  const fetchStatuses = useCallback(
    async queryParams => {
      try {
        const nextQueryParams = getNextQueryParams(queryParams, columns);
        const response =
          await RevenueOpportunityService.getRevenueOpportunityStatusesTable(
            nextQueryParams
          );
        return response;
      } catch (error) {
        console.error("Error fetching revenue opportunity statuses:", error);
        throw error;
      }
    },
    [columns]
  );

  return (
    <BaseTableV3
      columns={columns}
      headerIcon={REVENUE_OPPORTUNITY_STATUS_TABLE_CONSTANTS.headerIcon}
      header={REVENUE_OPPORTUNITY_STATUS_TABLE_CONSTANTS.header}
      queryKey={REVENUE_OPPORTUNITY_STATUS_TABLE_CONSTANTS.queryKey}
      className={REVENUE_OPPORTUNITY_STATUS_TABLE_CONSTANTS.className}
      tableName={REVENUE_OPPORTUNITY_STATUS_TABLE_CONSTANTS.tableName}
      fetchData={fetchStatuses}
      createButton={
        <FormDialog
          FormComponent={RevenueOpportunityStatusForm}
          modelType="Revenue Opportunity Status"
          contentClassName={STATUS_DIALOG_CLASS_NAME}
          onSuccess={invalidateRevenueOpportunityStatusQuery}
        />
      }
      invalidateData={invalidateRevenueOpportunityStatusQuery}
      enableSearch
      enableSettings
    />
  );
};

export default RevenueOpportunityStatusTableV3;
